import classNames from 'classnames';
import React from 'react';
import { useSelector } from '../hook-utils';
import { GosGraphType } from '../model';
import { selectGosLimits } from '../store/reducers/queues';
import './QualityIndicator.scss';

interface Props {
  value: number
  queueId: string
}

export default function QualityIndicator({ value, queueId }: Props) {
  const limits = useSelector(x => selectGosLimits(x, { queueId, type: GosGraphType.Gos }))
  if (!limits) { return null }

  return <div className='QualityIndicator'>
    {getText(value)}
    <div className={classNames('progress', getQuality(value, limits))} style={{ width: `${value}%` }}>
      <div className='progress-text'>{getText(value)}</div>
    </div>
  </div>
}

function getText(value: number) {
  return `${value.toFixed(0)}%`
}

function getQuality(value: number, [, yellow, red]: readonly [number, number, number]) {
  return value > yellow ? 'good'
       : value > red ? 'average'
       : 'bad'
}
